export * from "./partners.facade";
